import { ref } from "vue";
import useTip from "@/store/modules/useTip";
import { storeToRefs } from "pinia";

export default ({ isShare }) => {
    const show = ref(false);
    const tipStore = useTip();
    const { info } = storeToRefs(tipStore);

    function open() {
        show.value = true;
    }

    function close() {
        show.value = false;
    }

    !isShare.value && tipStore.getInfo(open);

    return { show, open, close, info };
};
